module.exports = __webpack_public_path__ + "static/media/referrals.07c2f480.svg";